import { RichTextQuill } from './_Templates/RichTextQuill';
import { RichTextTipTap } from './_Templates/RichTextTipTap';
import { RichTextMarkdown } from './_Templates/RichTextMarkdown';

/*
    🔥 REGISTRO DE EDITORES

    Mismo patrón que alerts y confirm: cambiás el id y toda la app usa
    otro editor sin tocar una sola vista.

    ⚠️ NO TODOS GUARDAN LO MISMO

    Quill y TipTap guardan HTML. Markdown guarda markdown.
    Si cambiás de familia con contenido ya cargado, ese contenido no se
    convierte solo. Elegí la familia AL PRINCIPIO del proyecto:
    migrar después es un script de conversión, no un cambio de select.

    format: 'html' | 'markdown'
*/

export const RICHTEXT_TEMPLATES = [

    {
        id: 'quillBasic', label: 'Quill — básico', format: 'html',
        component: RichTextQuill, props: { preset: 'basic' },
        description: 'Títulos, listas, enlaces y cita. El equilibrio para la mayoría.',
    },

    {
        id: 'quillMinimal', label: 'Quill — mínimo', format: 'html',
        component: RichTextQuill, props: { preset: 'minimal' },
        description: 'Negrita, cursiva y enlace. Para comentarios.',
    },

    {
        id: 'quillFull', label: 'Quill — completo', format: 'html',
        component: RichTextQuill, props: { preset: 'full' },
        description: 'Fuentes, colores, alineación, imágenes y video.',
    },

    {
        id: 'tiptap', label: 'TipTap (ProseMirror)', format: 'html',
        component: RichTextTipTap, props: {},
        description: 'Barra propia con tus tokens. El motor de Notion y Linear.',
    },

    {
        id: 'markdown', label: 'Markdown', format: 'markdown',
        component: RichTextMarkdown, props: {},
        description: 'Texto plano con vista previa. Sin HTML sucio al pegar.',
    },

];

export const RICHTEXT_TEMPLATE_IDS = RICHTEXT_TEMPLATES.map((item) => item.id);

const FALLBACK_TEMPLATE = RICHTEXT_TEMPLATES[0];

export const onResolveRichTextTemplate = (id) => (
    RICHTEXT_TEMPLATES.find((item) => item.id === id) ?? FALLBACK_TEMPLATE
);
